var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8714 0.146362C30.3069 -0.0487874 29.6933 -0.0487874 29.1288 0.146362L2.4621 9.36543C1.39111 9.73569 0.671088 10.7424 0.666762 11.8756C0.662436 13.0087 1.37475 14.0209 2.44289 14.3993L29.1096 23.8469C29.6857 24.051 30.3145 24.051 30.8906 23.8469L57.5573 14.3993C58.6254 14.0209 59.3377 13.0087 59.3334 11.8756C59.3291 10.7424 58.609 9.73569 57.5381 9.36543L30.8714 0.146362ZM30.0001 18.5043L11.4057 11.9165L30.0001 5.48819L48.5944 11.9165L30.0001 18.5043Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21434 20.1497C2.82427 19.6632 1.30298 20.3957 0.816453 21.7857C0.329927 23.1758 1.0624 24.6971 2.45247 25.1836L29.1191 34.517C29.6895 34.7166 30.3107 34.7166 30.881 34.517L57.5477 25.1836C58.9378 24.6971 59.6702 23.1758 59.1837 21.7857C58.6972 20.3957 57.1759 19.6632 55.7858 20.1497L30.0001 29.1747L4.21434 20.1497Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.816453 32.4524C1.30298 31.0623 2.82427 30.3299 4.21434 30.8164L30.0001 39.8414L55.7858 30.8164C57.1759 30.3299 58.6972 31.0623 59.1837 32.4524C59.6702 33.8425 58.9378 35.3638 57.5477 35.8503L30.881 45.1836C30.3107 45.3832 29.6895 45.3832 29.1191 45.1836L2.45247 35.8503C1.0624 35.3638 0.329927 33.8425 0.816453 32.4524Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21434 41.483C2.82427 40.9965 1.30298 41.729 0.816453 43.1191C0.329927 44.5091 1.0624 46.0304 2.45247 46.517L29.1191 55.8503C29.6895 56.0499 30.3107 56.0499 30.881 55.8503L57.5477 46.517C58.9378 46.0304 59.6702 44.5091 59.1837 43.1191C58.6972 41.729 57.1759 40.9965 55.7858 41.483L30.0001 50.5081L4.21434 41.483Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimization);
export default __webpack_public_path__ + "static/media/optimization.86c04b70a2d6fce051cd108e5445ffcf.svg";
export { ForwardRef as ReactComponent };